import { get } from "./api";

export const fetchTutorials= (params) => {
  const url = `/api/v2/tutorial/`;
  return get(url, params);
};